/*
 * Copyright (c) 2022 SARL SIGMA POLYNESIA
 */

import CustomerLink from '../customer/CustomerLink'
import EstatePhoto from '../estate/EstatePhoto'
import Ref from '../Ref'
import { getEstateLink } from '../../lib/links/estateLinks'
import { Table, Text } from '@mantine/core'
import AnchorLink from '../../../../client/js/components/AnchorLink'
import Amount from '../transaction/Amount'
import EstateDescription from '../EstateDescription'
import FurnishingAndEquipmentLabel from '../labels/FurnishingAndEquipmentLabel'

export type ProspectingResultListItemProps = {
  imageHeight?: number,
  imageWidth?: number,
  item: Estate
}

function ProspectingResultListItem (props: ProspectingResultListItemProps) {
  const {
    imageHeight = 90,
    imageWidth = 160,
    item
  } = props
  return (
    <Table.Tr>
      <Table.Td>
        <EstatePhoto
          height={imageHeight}
          photos={item.Photos}
          width={imageWidth}
        />
      </Table.Td>
      <Table.Td>
        <AnchorLink to={getEstateLink(item.id)}>
          <Ref value={item.reference} />
        </AnchorLink>
      </Table.Td>
      <Table.Td>
        <AnchorLink to={getEstateLink(item.id)}>
          {item.title}
        </AnchorLink>
        <Text size="xs">
          <EstateDescription
            transaction={item.transaction}
            type={item.type}
          />
        </Text>
        <Text size="xs">
          <FurnishingAndEquipmentLabel
            equipped={item.equipped}
            furnished={item.furnished}
          />
        </Text>
      </Table.Td>
      <Table.Td>
        {item.City?.name}
        {item.residence != null
          ? <Text size="xs">
            {item.residence}
          </Text>
          : null}
      </Table.Td>
      <Table.Td ta="end">
        {item.price != null
          ? <Amount value={item.price} inherit withCurrency />
          : null}
      </Table.Td>
      <Table.Td>
        {item.Owner
          ? <CustomerLink customer={item.Owner} />
          : null}
      </Table.Td>
    </Table.Tr>
  )
}

export default ProspectingResultListItem
